export default {
      id: "icon-5-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/icons.svg#icon-5",
      toString: function () {
        return this.url;
      }
    }